export const CATEGORIES = [
  {
    name: 'STEP BRACKETS',
    slug: 'step-brackets',
    image: '/img/products/step-brackets-clamps.png',
  },
  {
    name: 'PIPE CLAMPS',
    slug: 'pipe-clamps',
    image: '/img/products/ss-pvc-cpvc-upvc-clamps.png',
  },
  {
    name: 'PIPE HANGERS',
    slug: 'pipe-hangers',
    image: '/img/products/rubber-lined-split-clamp.png',
  },
  {
    name: 'CHANNEL SERIES',
    slug: 'channel-series',
    image: '/img/products/unistrut-channel.png',
  },
  {
    name: 'ELECTRICAL ACCESSORIES',
    slug: 'electrical-accessories',
    image: '/img/products/metal-fan-hook-box.png',
  },
  {
    name: 'CABLE MANAGEMENT',
    slug: 'cable-management',
    image: '/img/products/perforated-cable-tray.png',
  },
  {
    name: 'FASTENERS',
    slug: 'fasteners',
    image: '/img/products/anchor-bolt-ss304.png',
  },
];

// Helper function to get category by slug
export const getCategoryBySlug = (slug) => {
  return CATEGORIES.find((category) => category.slug === slug);
};
